export default "/images/b91f2a8dc63cec93e053e5ffcc4edff3.avif";